import Badge from '~/core/ui/Badge'

export function InfoBadge({ text }: { text: string }) {
  return (
    <Badge color="info" className="w-fit pointer-events-none ">
      {text}
    </Badge>
  )
}
